import { EnvService } from './env.service';

declare global {
    interface Window {
        app: any,
        dataLayer: any
    }
}
window.app = window.app || {};

/**
 * Read environment properties from the window object and inject them in EnvService to make
 * them available to Angular.
 */
export const EnvServiceFactory = () => {
    // Create env
    const env = new EnvService();

    // Read environment variables from browser window
    const browserWindow: any = window || {};
    const browserWindowEnv = browserWindow.app.env || {};

    // Assign environment variables from browser window to env
    for (const key in browserWindowEnv) {
        if (Object.hasOwnProperty.call(browserWindowEnv, key)) {
            env[key] = window.app.env[key];
        }
    }

    return env;
};

export const EnvServiceProvider = {
    provide: EnvService,
    useFactory: EnvServiceFactory,
    deps: [],
};
